import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';

class EmpresaRedirect extends AbstractComponent {        
    show() {        
        if(!this.props.visible)
            return ;

        return (
            <Fragment>
                <div className="text-center">
                    <h3>
                        AGUARDE REDIRECIONANDO
                    </h3>
                </div>                                                            
            </Fragment>
        );
    }    
    
    render() {
        return(      
            <Fragment>
                { this.show() }                                            
            </Fragment>      
        )
    }
}

export default EmpresaRedirect;